import {
  Button,
  Checkbox,
  ColorInput,
  Flex,
  Grid,
  Stack,
  Text,
  TextInput,
} from '@mantine/core'
import { modals } from '@mantine/modals'

import useCreateTag from '../../hooks/useCreateTag.hook'

const CreateTagContent = ({
  onMutationSuccess,
}: {
  onMutationSuccess: () => void
}) => {
  const { createTag, createMutationStatus, rowValuesForm } = useCreateTag()

  const handleCreate = async () => {
    await createTag()
    onMutationSuccess()
  }

  return (
    <>
      <Stack align="center" justify="center" gap="md">
        <Text size={'20px'} fw={700}>
          Create New Tag
        </Text>
        <Grid gutter={35} justify={'space-between'} p={10} mb={20}>
          <Grid.Col span={12}>
            <TextInput
              label="Name"
              required
              {...rowValuesForm.getInputProps('name')}
            />
          </Grid.Col>
          <Grid.Col span={3}>
            <Checkbox
              radius="4px"
              label="Is Protected"
              {...rowValuesForm.getInputProps('isProtected')}
            />
          </Grid.Col>
          <Grid.Col span={3}>
            <Checkbox
              radius="4px"
              label="Is Hided"
              {...rowValuesForm.getInputProps('isHided')}
            />
          </Grid.Col>
          <Grid.Col span={3}>
            <Checkbox
              label="Is Not Eligible"
              {...rowValuesForm.getInputProps('isNotEligible')}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <ColorInput
              label="Color"
              {...rowValuesForm.getInputProps('color')}
            />
          </Grid.Col>
        </Grid>
      </Stack>
      <Flex justify="space-between" align="flex-start" mt="lg">
        <Button onClick={() => modals.closeAll()} variant="outline">
          Cancel
        </Button>
        <Button
          loading={createMutationStatus === 'pending'}
          type="submit"
          variant="filled"
          onClick={handleCreate}
          disabled={!rowValuesForm.isValid('name')}
        >
          Create Tag
        </Button>
      </Flex>
    </>
  )
}
export default CreateTagContent
